module.exports = __webpack_public_path__ + "static/img/banner.2c91d36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner.png
// module id = Yz7+
// module chunks = 1